module.exports = __webpack_public_path__ + "static/media/plane(23).b4c08278.PNG";